"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
var profile_1 = require("./profile");
Object.defineProperty(exports, "Profile", { enumerable: true, get: function () { return __importDefault(profile_1).default; } });
//# sourceMappingURL=index.js.map